// extracted by mini-css-extract-plugin
module.exports = {"addValue":"AddValueModal_addValue__37o3C","buttons":"AddValueModal_buttons__2cFZu"};